module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_plan_show_bg_04-2fdb94b7bedc02fe6d6439d3df942b42.png";